import React, { Component } from 'react';
import RadarChart from './RadarChart';
import { withAnalyticsAppContext } from '../../context/analytics-app-context';
import { isEmpty } from '../../utils/object-utils';
import './analytics-pages-radar.scss';
import DecrementIcon from '../icons/DecrementIcon';
import IncrementIcon from '../icons/IncrementIcon';

const DEFAULT_SCALE = 10;
const MINIMUM_SCALE = 1;
const DEFAULT_ZOOM_DISTANCE = 1.2;

class AnalyticsPagesRadar extends Component {
    constructor(props) {
        super(props);

        this.onIncrementClick = this.onIncrementClick.bind(this);
        this.onDecrementClick = this.onDecrementClick.bind(this);
        this.state = { scales: DEFAULT_SCALE, zoomDistance: DEFAULT_ZOOM_DISTANCE };
    }

    onIncrementClick() {
        const { scales } = this.state;
        if (scales === DEFAULT_SCALE) {
            return;
        }

        this.setState((prevState) => {
            return {
                ...prevState,
                scales: prevState.scales + 1,
                zoomDistance: prevState.zoomDistance + 0.1
            };
        });
    }

    onDecrementClick() {
        const { scales } = this.state;
        if (scales === MINIMUM_SCALE) {
            return;
        }

        this.setState((prevState) => {
            return {
                ...prevState,
                scales: prevState.scales - 1,
                zoomDistance: prevState.zoomDistance - 0.1
            };
        });
    }


    render() {
        const { appContext } = this.props;
        const { scales, zoomDistance } = this.state;
        const { loading } = appContext;
        const { analyticsPagesRadarData } = appContext.analyticsData || {};
        const radarData = isEmpty(analyticsPagesRadarData) ? [] : [
            {
                size: 750,
                captions: analyticsPagesRadarData.radarCaptions,
                chart: [
                    // data
                    {
                        data: analyticsPagesRadarData.radarData,
                        meta: { color: '#1e88e5' }
                    }
                ]
            },
        ];
        const isLoading = loading || isEmpty(analyticsPagesRadarData);
        return (
            <div className='analytics-grid-item-root analytics-grid-pages-radar-root analytics-component grid-item'>
                <div className='analytics-grid-item-data'>
                    <div className='card-header-root'>
                        <div className='card-header-content'>
                            <span className='card-header-title'>
                                <h6> {'Pages data radar'}</h6>
                            </span>
                        </div>
                    </div>

                    <div className='card-body'>

                        {loading && 'Loading...'}
                        {isLoading ?
                            null :
                            radarData.map((data, index) => {
                                data.options = { scales, zoomDistance };
                                return (
                                    <div className="chart-container" key={`${index}-${data.name}`}>
                                        <h2>{data.name}</h2>
                                        <span>
                                            <h3>Scale: {scales}
                                                <IncrementIcon onClick={this.onIncrementClick}></IncrementIcon>
                                                <DecrementIcon onClick={this.onDecrementClick}></DecrementIcon>
                                            </h3>
                                        </span>
                                        <br />
                                        <RadarChart
                                            captions={data.captions}
                                            data={data.chart}
                                            options={data.options}
                                            size={data.size}
                                            id={`chart-${index}`}
                                        />
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        );
    }
}

export default withAnalyticsAppContext(AnalyticsPagesRadar);
